import { useTranslation } from "react-i18next";
import { BiLoaderAlt } from "react-icons/bi";

const AppLoading = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 min-h-screen flex items-center justify-center w-full bg-zinc-300/40">
      <BiLoaderAlt
        className={`w-10 h-10 animate-spin text-blue-500 `}
        role="presentation"
      />
      {t("Application.Loading")}
    </div>
  );
};

export default AppLoading;
